/* eslint-disable import/no-extraneous-dependencies */
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import * as shippingInfoActions from '../../actions';
import injectReducer from '../../../../utils/injectReducer';
import injectSaga from '../../../../utils/injectSaga';
import saga from '../../sagas';
import shippingInfo from '../../reducer';
import * as shippingInfoSelectors from '../../selectors/shippingInfoSelectors';
import { getZipCode } from '../../../Cart/selectors/cartSelectors';
import * as cartActions from '../../../../services/Cart/actions';
import ShippingOptionsComp from '../../../../components/Web/ShippingInfo/redesign/ShippingOptions';
import { getCurrentShippingValue, getSelectedShippingType } from '../../shippingHelper';

const mapStateToProps = (state) => {
  const selectShippingData = shippingInfoSelectors.selectShippingData(state);
  const shippingInfoState = state.shippingInfo;
  const shippingInfoDetails = state.shippingInfo.ShippingInfoDetails || {};
  const { selectedShippingOption, openISPUModal } = state.shippingInfo;
  const storeLists = state.shippingInfo.storeList;
  const cartDetails = state.cartDetails && state.cartDetails.cartDetailsJson ? state.cartDetails.cartDetailsJson : {};
  const shippingAddress = state.cartDetails ? state.cartDetails.cartDetailsJson && state.cartDetails.cartDetailsJson.shippingDetails : {};
  const isbillingInfoEdited = state.contactInfo && state.contactInfo.billingInfoEdited ? state.contactInfo.billingInfoEdited : false;

  const zipcode = getZipCode(state, isbillingInfoEdited);
  const shippingHeader = state && state.shippingInfo?.shippingHeader;
  const cradleResponseDetails = state.SessionValues?.shippingCradleValue;
  const currrentValue = getCurrentShippingValue(cartDetails);
  const showPickupInfoTab = state.shippingInfo?.showPickupInfoTab;
  const selectOtherOption = state.shippingInfo?.selectOtherOption;
  const selectedExpressCheckout = state.shippingInfo?.selectedExpressCheckout;
  const removedWHWPlus= state.shippingInfo?.removedWHWPlus;

  return {
    selectShippingData,
    shippingInfoState,
    shippingInfoDetails,
    selectedShippingOption: selectedShippingOption || {},
    cartDetails,
    shippingAddress,
    selectOtherOption,
    removedWHWPlus,
    selectedExpressCheckout,
    isShippingOptionAvailable:
      cartDetails &&
      cartDetails?.shippingDetails &&
      cartDetails?.shippingDetails?.[0] &&
      cartDetails?.shippingDetails?.[0]?.shippingCode &&
      cartDetails?.shippingDetails?.[0]?.shippingCode,
    shippingDescription:
      cartDetails && cartDetails?.shippingDetails && cartDetails?.shippingDetails?.[0] && cartDetails?.shippingDetails?.[0]?.shippingDescription,
    defaultSelectedSlot:
      currrentValue ||
      (shippingInfoDetails &&
        shippingInfoDetails?.lines &&
        shippingInfoDetails?.lines?.[0] &&
        shippingInfoDetails?.lines?.[0]?.shippingOptions &&
        getSelectedShippingType(
          shippingInfoDetails?.lines?.[0]?.shippingOptions,
          true,
          shippingInfoDetails && shippingInfoDetails?.lines?.[0]?.selectedOptionCode,
        )),
    shippingOption:
      shippingInfoDetails &&
      shippingInfoDetails?.lines?.[0] &&
      shippingInfoDetails?.lines?.[0]?.shippingOptions &&
      getSelectedShippingType(
        shippingInfoDetails?.lines?.[0]?.shippingOptions,
        true,
        shippingInfoDetails && shippingInfoDetails?.lines?.[0]?.selectedOptionCode,
      ),
    selectedOptionCode: shippingInfoDetails && shippingInfoDetails?.lines?.[0]?.selectedOptionCode,
    storeLists,
    zipcode,
    isbillingInfoEdited,
    shippingHeader,
    openISPUModal,
    cradleResponseDetails,
    showPickupInfoTab,
  };
};
function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...shippingInfoActions, ...cartActions }, dispatch);
}
const withReducer = compose(injectReducer({ key: 'shippingInfo', reducer: shippingInfo }));

const withConnect = connect(mapStateToProps, mapDispatchToProps);

const withSaga = injectSaga({ key: 'shippingInfo', saga });
export default withRouter(compose(withSaga, withReducer, withConnect)(ShippingOptionsComp));
